/**
 * ajax 请求头部 login-channel
 * @returns
 */
export default function getRequestChannel(channel) {
    var _channel = channel ||
        (Boolean(window.sessionStorage.getItem('emp_channel'))
            ? JSON.parse(window.sessionStorage.getItem('emp_channel')).use_channel
            : '');
    if (_channel && /(FDCS)/.test(_channel)) {
        return 'f';
    }
    if ((!_channel && /(\/ssChangeRefund)/.test(window.location.href)) ||
        (_channel && _channel.toLocaleLowerCase() === 'ss')) {
        return 's';
    }
    return 'm';
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/request/getRequestChannel.js
// module id = null
// module chunks = 